/* ============================
   FRONTEND TYPES
============================ */

export interface User {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  role: 'beta' | 'user' | 'admin';
  betaExpiresAt?: string;
  betaTermsAgreed?: boolean;
  createdAt: Date;
}

export interface Report {
  id: string;
  userId: string;
  title: string;
  content: string;
  modelUsed: string;
  workspaceId: string | null;
  createdAt: Date;
  updatedAt: Date;
}

export interface SharedReport {
  id: string;
  reportId: string;
  sharedWithEmail: string;
  sharedById: string;
  permission: string;
  createdAt: Date;
}

/* ============================
   AI MODELS
============================ */
export const aiModels = {
  openai: {
    id: "openai",
    name: "OpenAI GPT-5",
    description: "Deep research and comprehensive analysis",
    color: "chart-1",
  },
  openrouter1: {
    id: "openrouter1",
    name: "OpenRouter Model 1",
    description: "Quick market insights",
    color: "chart-2",
  },
  openrouter2: {
    id: "openrouter2",
    name: "OpenRouter Model 2",
    description: "Alternative analysis engine",
    color: "chart-3",
  },
} as const;

export type AIModelId = keyof typeof aiModels;

/* ============================
   INDEX INTEGRATION TYPES
============================ */

export interface IndexEnrichment {
  enabled: boolean;
  marketContext?: boolean;
  competitors?: boolean;
  trends?: boolean;
  sources?: boolean;
}

export interface EnrichedPrompt {
  originalPrompt: string;
  enrichedPrompt: string;
  indexData?: {
    marketContext?: string;
    competitors?: string[];
    trends?: string[];
    insights?: string[];
  };
  sources?: string[];
  confidence?: number;
}
